module.exports = __webpack_public_path__ + "newWebTMS/img/logo.b857b2a9.png";